/* eslint-disable react/button-has-type, jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary, jsx-a11y/no-autofocus, react/no-unescaped-entities */
/* eslint-disable no-unused-vars, no-useless-return, curly, nonblock-statement-body-position */
/* eslint-disable no-confusing-arrow */
import React, { useState, useEffect } from 'react';
import { SUB_SCREENS } from '../../constants';
import { CloseIcon, TableActions, F } from '../CommonUI';
import { apiCall } from '../../utils/api';
import EmployeeMasterDeleteConfirm from './EmployeeMasterDeleteConfirm';

/**
 * Facilities Sub-Screen
 * ┌──────────────────────────────────────────────────────────────┐
 * │  GET    /api/facilities/:empCode        → [{ id, ... }]     │
 * │  POST   /api/facilities/:empCode        → { id, ... }       │
 * │  PUT    /api/facilities/:empCode/:id    → { success }       │
 * │  DELETE /api/facilities/:empCode/:id    → { success }       │
 * └──────────────────────────────────────────────────────────────┘
 */
function FacilitiesScreen({
  empName,
  empCode,
  onClose,
  opts,
  fetchFacilityCategories,
  readOnly,
}) {
  const FAC_INIT = {
    facility: '',
    dependent: '',
    category: '',
    limit: '',
    cost: '',
    remarks: '',
    fromDate: '',
    toDate: '',
  };
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ ...FAC_INIT });
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [depList, setDepList] = useState([]);
  const toIsoDate = value =>
    value ? new Date(`${value}T00:00:00.000Z`).toISOString() : null;
  const normalizeFacilityItem = item => ({
    ...item,
    facility: item?.facility || item?.Facility || '',
    dependent: item?.dependent ?? item?.Dependent ?? '',
    category: item?.category || item?.facilityCat || item?.FacilityCat || '',
    fromDate:
      item?.fromDate ||
      (item?.stDt ? item.stDt.slice(0, 10) : '') ||
      (item?.StDt ? item.StDt.slice(0, 10) : ''),
    toDate:
      item?.toDate ||
      (item?.endDt ? item.endDt.slice(0, 10) : '') ||
      (item?.EndDt ? item.EndDt.slice(0, 10) : ''),
    limit: item?.limit ?? item?.Limit ?? '',
    cost: item?.cost ?? item?.Cost ?? '',
    remarks: item?.remarks ?? item?.Remarks ?? '',
  });

  useEffect(() => {
    if (!empCode) return;
    const req = apiCall('/envision/api/employee/get-facility', {
      method: 'POST',
      body: { empCd: empCode },
    });
    if (!req) return;
    setLoading(true);
    req
      .then(data => {
        const list = Array.isArray(data?.result) ? data.result : [];
        setItems(list.map(normalizeFacilityItem));
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load facilities.');
        setLoading(false);
      });
  }, [empCode]);

  useEffect(() => {
    if (readOnly) {
      setShowForm(false);
      setEditing(null);
    }
  }, [readOnly]);

  useEffect(() => {
    if (form.facility) {
      fetchFacilityCategories(form.facility, empCode);
    }
  }, [form.facility, empCode, fetchFacilityCategories]);

  const cf = (n, v) => setForm(p => ({ ...p, [n]: v }));
  const resetForm = () => {
    setForm({ ...FAC_INIT });
    setShowForm(false);
    setEditing(null);
  };

  const doSave = () => {
    const limitFilled = String(form.limit ?? '').trim() !== '';
    if (
      !form.facility ||
      !form.category ||
      !limitFilled ||
      !form.fromDate ||
      !form.toDate
    ) {
      setError('Please fill all mandatory fields.');
      return;
    }
    setError(null);
    const req = apiCall('/envision/api/employee/create-facility', {
      method: 'POST',
      body: {
        empCd: empCode,
        facility: form.facility,
        dependent:
          form.dependent === '' ||
          form.dependent === null ||
          form.dependent === undefined
            ? 0
            : Number(form.dependent),
        facilityCat: form.category,
        limit:
          form.limit === '' || form.limit === null ? null : Number(form.limit),
        cost: form.cost === '' || form.cost === null ? null : Number(form.cost),
        stDt: toIsoDate(form.fromDate),
        endDt: toIsoDate(form.toDate),
        remarks: form.remarks || null,
      },
    });
    if (req) {
      req
        .then(data => {
          if (editing !== null) {
            setItems(p =>
              p.map((d, i) =>
                i === editing ? { ...form, id: d.id || items[editing].id } : d,
              ),
            );
          } else setItems(p => [...p, { ...form, id: data.id }]);
          resetForm();
        })
        .catch(() => {
          setError('Failed to save.');
        });
    } else {
      if (editing !== null)
        setItems(p => p.map((d, i) => (i === editing ? { ...form } : d)));
      else setItems(p => [...p, { ...form }]);
      resetForm();
    }
  };
  const doEdit = i => {
    setForm({ ...items[i] });
    setEditing(i);
    setShowForm(true);
  };

  const facilityDeleteSummary = idx => {
    const item = items[idx];
    if (!item) return '—';
    const facLabel =
      opts?.facilityTypes?.find(x => x.value === item.facility)?.label ||
      item.facility;
    const catLabel =
      opts?.facilityCategories?.find(x => x.value === item.category)?.label ||
      item.category;
    return `${facLabel || '—'} — ${catLabel || '—'}`;
  };

  const openDeleteConfirm = i => {
    setDeleteIndex(i);
    setDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    if (deleteLoading) return;
    setDeleteModalOpen(false);
    setDeleteIndex(null);
  };

  const performDelete = () => {
    if (deleteIndex == null) return;
    const i = deleteIndex;

    const finishOk = () => {
      setDeleteLoading(false);
      setDeleteModalOpen(false);
      setDeleteIndex(null);
    };

    const req = apiCall('/envision/api/employee/delete-facility', {
      method: 'POST',
      body: {
        empCd: empCode,
        facility: items[i]?.facility || null,
        dependent:
          items[i]?.dependent === '' ||
          items[i]?.dependent === null ||
          items[i]?.dependent === undefined
            ? 0
            : Number(items[i]?.dependent),
      },
    });
    if (req) {
      setDeleteLoading(true);
      req
        .then(() => {
          setItems(p => p.filter((_, j) => j !== i));
          finishOk();
        })
        .catch(() => {
          setError('Failed to delete.');
          setDeleteLoading(false);
        });
    } else {
      setItems(p => p.filter((_, j) => j !== i));
      finishOk();
    }
  };

  return (
    <div className="ov">
      <div
        className="sub-modal sub-modal-lg"
        onClick={e => e.stopPropagation()}
      >
        <div className="sub-modal-top comp-modal-top">
          <div className="sub-modal-title">
            <div className="sub-modal-title-row sub-modal-title-row--stacked comp-modal-title-row">
              <span className="sub-modal-icon sub-modal-icon--lg comp-modal-icon-shell">
                <span className="comp-modal-icon-inner">
                  {SUB_SCREENS[5].icon}
                </span>
              </span>
              <div className="sub-modal-title-block">
                <h2>Facilities</h2>
                {empCode && (
                  <span className="sub-modal-emp sub-modal-emp--stacked">
                    {[empName, empCode].filter(Boolean).join(' \u00b7 ')}
                  </span>
                )}
              </div>
            </div>
          </div>
          <button className="mdl-x" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="sub-modal-body">
          {error && (
            <div
              style={{
                padding: '12px 20px',
                background: 'var(--red-l)',
                color: 'var(--red)',
                fontSize: 13,
                fontWeight: 500,
                marginBottom: 12,
                borderRadius: 'var(--r)',
              }}
            >
              {error}
            </div>
          )}
          {loading ? (
            <div className="sub-empty">
              <span>Loading facilities...</span>
            </div>
          ) : (
            <>
              {showForm && !readOnly && (
                <div className="dep-form">
                  <div className="dep-form-title">
                    {editing !== null ? 'Edit Facility' : 'Add New Facility'}
                  </div>
                  <div className="dep-sections" style={{ padding: '18px' }}>
                    <div className="dep-sec-grid dep-sec-grid-4">
                      <F
                        label="Facility"
                        name="facility"
                        value={form.facility}
                        onChange={cf}
                        options={opts?.facilityTypes}
                        required
                      />
                      <F
                        label="Category"
                        name="category"
                        value={form.category}
                        onChange={cf}
                        options={opts?.facilityCategories}
                        required
                      />
                      <F
                        label="Dependent"
                        name="dependent"
                        value={form.dependent}
                        onChange={cf}
                        options={opts?.dependents}
                      />
                      <F
                        label="Limit"
                        name="limit"
                        value={form.limit}
                        onChange={cf}
                        type="number"
                        required
                      />
                      <F
                        label="From"
                        name="fromDate"
                        value={form.fromDate}
                        onChange={cf}
                        type="date"
                        required
                      />
                      <F
                        label="To"
                        name="toDate"
                        value={form.toDate}
                        onChange={cf}
                        type="date"
                        required
                      />
                      <F
                        label="Cost"
                        name="cost"
                        value={form.cost}
                        onChange={cf}
                        type="number"
                      />
                      <F
                        label="Remarks"
                        name="remarks"
                        value={form.remarks}
                        onChange={cf}
                        style={{ gridColumn: 'span 2' }}
                      />
                    </div>
                  </div>
                  <div className="dep-form-actions">
                    <button className="btn em-btn" onClick={resetForm}>
                      Cancel
                    </button>
                    <button className="btn em-btn em-btn-p" onClick={doSave}>
                      {editing !== null ? 'Update' : 'Save'}
                    </button>
                  </div>
                </div>
              )}
              {items.length > 0 ? (
                <div
                  className="dep-table-wrap"
                  style={{ marginTop: showForm && !readOnly ? 16 : 0 }}
                >
                  <table className="dep-table dep-table--facilities">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Facility</th>
                        <th>Dependent</th>
                        <th>Category</th>
                        <th>Limit</th>
                        <th>Cost</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Remarks</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, i) => {
                        const facLabel =
                          opts?.facilityTypes?.find(
                            x => x.value === item.facility,
                          )?.label || item.facility;
                        const catLabel =
                          opts?.facilityCategories?.find(
                            x => x.value === item.category,
                          )?.label || item.category;
                        const depLabel =
                          opts?.dependents?.find(
                            x => x.value === item.dependent,
                          )?.label || item.dependent;

                        return (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{facLabel}</td>
                            <td>{depLabel || '—'}</td>
                            <td>{catLabel || '—'}</td>
                            <td>{item.limit || '—'}</td>
                            <td>{item.cost || '—'}</td>
                            <td>{item.fromDate}</td>
                            <td>{item.toDate}</td>
                            <td>{item.remarks || '—'}</td>
                            <td>
                              <TableActions
                                readOnly={readOnly}
                                onEdit={() => doEdit(i)}
                                onDelete={() => openDeleteConfirm(i)}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                !showForm && (
                  <div className="sub-empty">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                        stroke="#cbd5e1"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M9 22V12h6v10"
                        stroke="#cbd5e1"
                        strokeWidth="1.5"
                      />
                    </svg>
                    <span>No facilities found.</span>
                  </div>
                )
              )}
              {!showForm && !readOnly && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: 16,
                  }}
                >
                  <button
                    className="btn em-btn em-btn-p"
                    onClick={() => setShowForm(true)}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 5v14m-7-7h14"
                        stroke="#fff"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                      />
                    </svg>
                    Add Facility
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <EmployeeMasterDeleteConfirm
        isOpen={deleteModalOpen}
        toggle={closeDeleteModal}
        onConfirm={performDelete}
        loading={deleteLoading}
        message={
          deleteIndex != null && items[deleteIndex] ? (
            <>
              Are you sure you want to delete this facility (
              <span className="em-delete-confirm__highlight">
                {facilityDeleteSummary(deleteIndex)}
              </span>
              )?
            </>
          ) : null
        }
      />
    </div>
  );
}

export default FacilitiesScreen;
